import { render, staticRenderFns } from "./PostItem.vue?vue&type=template&id=282f5952&scoped=true&"
import script from "./PostItem.vue?vue&type=script&lang=js&"
export * from "./PostItem.vue?vue&type=script&lang=js&"
import style0 from "./PostItem.vue?vue&type=style&index=0&id=282f5952&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282f5952",
  null
  
)

export default component.exports